import App from 'next/app';
import React from 'react';

import { trackPageView } from 'utils/Tracking';
import { CookieBanner } from 'components/CookieBanner';

import { AppThemeBase } from './AppThemeBase';

import { FacebookPixel } from 'components/FacebookPixel';

import { RouteLoader } from '@www/components/Loader/RouteLoader';

import {
  isProduction,
  isDevelopment,
  currentEnvironment,
} from 'utils/environment';

import * as Sentry from '@sentry/browser';
import { catchError } from 'utils/errorHandler';

import '@www/locales/i18n';

import { IntercomComponent } from 'components/IntercomComponent';

if (process.env.REACT_APP_SENTRY_DSN && !isDevelopment()) {
  const DEBUG = !isProduction();
  Sentry.init({
    debug: DEBUG,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `${process.env.REACT_APP_NAME}-${process.env.REACT_APP_VERSION}`,
    environment: currentEnvironment(),
    beforeSend(event) {
      if (DEBUG) {
        // eslint-disable-next-line no-console
        console.error(event.message, event);
      }

      return event;
    },
  });
}

class AppBaseComponent extends App {
  constructor(props) {
    super(props);
  }
  async componentDidMount() {
    /**
     * First landing
     */

    trackPageView({ path: this.props.router.route });

    // hotjar.initialize('1863253', 6);

    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles && jssStyles.parentNode)
      jssStyles.parentNode.removeChild(jssStyles);
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    catchError(error);

    super.componentDidCatch(error, errorInfo);
  }

  render() {
    const { children } = this.props;
    return (
      <AppThemeBase>
        <RouteLoader />

        <CookieBanner />
        <FacebookPixel />
        <IntercomComponent />

        {children}
      </AppThemeBase>
    );
  }
}

export const AppBase = AppBaseComponent;
